import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from '../views/login.vue'


Vue.use(VueRouter)
const changePush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return changePush.call(this, location).catch(err => err);
}
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    beforeEnter: (to, form, next) => {
      if (null != localStorage.getItem('token')) {
        next()
      } else {
        next('/login')
      }
      // next()
    },
    children: [
      {
        path: '/user',
        name: 'user',
        component: () => import('../views/user/user.vue')
      },
      {
        path: '/service',
        name: 'service',
        component: () => import('../views/service/service.vue')
      },
      {
        path: '/serviceCategory',
        name: 'serviceCategory',
        component: () => import('../views/serviceCategory/serviceCategory.vue')
      },
      {
        path: '/purchaseRecord',
        name: 'purchaseRecord',
        component: () => import('../views/purchaseRecord/purchaseRecord.vue')
      },
      {
        path: '/admin',
        name: 'admin',
        component: () => import('../views/system/admin.vue')
      },
      {
        path: '/project',
        name: 'project',
        component: () => import('../views/system/project.vue')
      },
      {
        path: '/configure',
        name: 'configure',
        component: () => import('../views/system/configure.vue')
      },
      {
        path: '/pointsAllocationts',
        name: 'pointsAllocationts',
        component: () => import('../views/system/points.vue')
      },
      {
        path: '/region',
        name: 'region',
        component: () => import('../views/system/region.vue')
      },
      {
        path: '/master',
        name: 'master',
        component: () => import('../views/master/master.vue')
      }, {
        path: '/appIntro',
        name: 'appIntro',
        component: () => import('../views/appIntro/appintro.vue')
      },{
        path: '/topSetting',
        name: 'topSetting',
        component: () => import('../views/topSetting/setting.vue')
      }, {
        path: '/topRecord',
        name: 'topRecord',
        component: () => import('../views/topSetting/record.vue')
      }, {
        path: '/memberSetting',
        name: 'memberSetting',
        component: () => import('../views/memberSetting/setting.vue')
      }, {
        path: '/memberRecord',
        name: 'memberRecord',
        component: () => import('../views/memberSetting/record.vue')
      }, {
        path: '/pointsSetting',
        name: 'pointsSetting',
        component: () => import('../views/pointsSetting/setting.vue')
      }, {
        path: '/pointsRecord',
        name: 'pointsRecord',
        component: () => import('../views/pointsSetting/record.vue')
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  }
]

const router = new VueRouter({
  routes
})

export default router
